import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)

import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

require('@/store/subscriber')

axios.defaults.baseURL = '/api/'

import dateLatin from './utils/date.filter'
import capitalize from './utils/text.filters'
import FloatToFixed from './utils/number.filters'

Vue.filter('capitalize', capitalize)
Vue.filter('dateLatin', dateLatin)
Vue.filter('FloatToFixed', FloatToFixed)

Vue.config.productionTip = false

store.dispatch('auth/attempt', localStorage.getItem('token'))
.then(() => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
})
